import getCanUpdateSub from './getCanUpdateSub';
import getIsRenewalEligible from './getIsRenewalEligible';

export default function canRenewOrUpdateSubscription(state) {
  return getIsRenewalEligible(state) || getCanUpdateSub(state);
}
